/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import Highcharts from 'highcharts/highstock';
import { Panel, Select, SelectOption } from 'appkit-react';
import {
    Col, Row,
} from 'react-bootstrap';

const DetailChart = ({
    columnWiseDQScore, rowsProcesed, dimensions, selectedDimensionId, onColumnBarSelection, selectedColumnId, columnsList, onDimensionDropDownClose, onColumnDropDownClose,
}) => {
    const panelTitle = 'Dimension(s) Score by Column';
    let barChart;
    const [dimensionOptions, setDimensionOptions] = useState(selectedDimensionId);
    const [columnOptions, setColumnOptions] = useState(selectedColumnId);
    const [mapScoreData, setMapScoreData] = useState([]);

    useEffect(() => {
        if (columnWiseDQScore && columnWiseDQScore.length) {
            const pointPaddingStartValue = 0;
            const scoreData = columnWiseDQScore.map(x => ({
                name: dimensions.filter(dm => dm.dimensionId === x.dimensionId).map(val => val.dimensionName)[0],
                data: x.data && x.data.map(y => ({
                    name: y.title,
                    y: y.value,
                })),
                pointPadding: pointPaddingStartValue,
            }));
            setMapScoreData(scoreData);
        }
    }, [columnWiseDQScore]);
    useEffect(() => {
        barChart = new Highcharts.Chart({
            chart: {
                type: 'column',
                renderTo: 'hierarchy-bar',
                style: {
                    cursor: 'pointer',
                },
            },
            title: {
                text: null,
            },
            xAxis: {
                type: 'category',
                tickWidth: 0,
                tickLength: 0,
                labels: {
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                    },
                },
                lineColor: '#e7e7e8',
                gridLineColor: '#e7e7e8',
                min: 0,
                max: 7,
                scrollbar: {
                    enabled: true,
                },
            },
            yAxis: {
                max: 100,
                title: {
                    text: 'DQ Score',
                },
                lineColor: '#e7e7e8',
                gridLineColor: '#e7e7e8',
                labels: {
                    style: {
                        fontSize: '12px',
                    },
                },
            },
            legend: {
                enabled: true,
            },
            plotOptions: {
                series: {
                    maxPointWidth: 40,
                    // borderWidth: 0,
                    pointPadding: 0.1,
                    groupPadding: 0.2,
                    dataLabels: {
                        enabled: true,
                        y: 0,
                        style: {
                            fontSize: 8,
                            textDecoration: 'bold',
                        },
                        format: '{y}',
                        color: '#333333',
                    },
                    tooltip: {
                        headerFormat: '{point.key}<br>',
                        pointFormat:
                            `<span style="color:{point.color}"> \u25CF</span>  {series.name}: <b>{point.y:.0f}</b>
                            <br/>
                        <span style="color:{point.color}">\u25CF</span> RowsProcessed : <b>${rowsProcesed}</b>
                            `,
                        shared: true,
                    },
                },
                column: {
                    // borderRadius: 2,
                    grouping: true,
                    shadow: false,
                    events: {
                        click: e => {
                            onColumnBarSelection(e);
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            accessibility: {
                announceNewData: {
                    enabled: true,
                },
            },
            series: mapScoreData,
        });
        return () => {
            barChart.destroy();
        };
    }, [mapScoreData]);
    return (
        <div style={{ margin: '0.1rem' }}>
            <Panel
                title={panelTitle}
                renderRight={() => (
                    <div>
                        <Row>
                            <Col>
                                <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Column</label>
                                <div style={{ width: '200px' }}>
                                    <Select
                                        onClose={() => onColumnDropDownClose(columnOptions)}
                                        onSelect={e => {
                                            const data = [].concat(e);
                                            setColumnOptions(data);
                                        }}
                                        value={columnOptions}
                                        multiple
                                        showSelectAll
                                        placeholder="Select Column"
                                    >
                                        {columnsList && columnsList.map(({ columnId, columnName }) => (
                                            <SelectOption key={columnId} value={columnId}>
                                                {columnName}
                                            </SelectOption>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col>
                                <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Dimension</label>
                                <div style={{ width: '150px' }}>
                                    <Select
                                        onClose={() => onDimensionDropDownClose(dimensionOptions)}
                                        onSelect={e => {
                                            const data = [].concat(e);
                                            setDimensionOptions(data);
                                        }}
                                        value={dimensionOptions}
                                        multiple
                                        showSelectAll
                                        placeholder="Select Dimension"
                                    >
                                        {dimensions && dimensions.map(({ dimensionId, dimensionName }) => (
                                            <SelectOption key={dimensionId} value={dimensionId}>
                                                {dimensionName}
                                            </SelectOption>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            >
                <div id="hierarchy-bar" style={{ marginTop: '2rem' }} />
            </Panel>
        </div>
    );
};

export default DetailChart;
